<template>
    <div>
        <div class="item-title">成绩详情</div>
        <div class="list-title">
            <div>学生姓名</div>
            <div>班级</div>
            <div>成绩</div>
        </div>
        <div class="list" v-for="l in list" :key="l.studentName">
            <div>{{l.studentName}}</div>
            <div>{{l.gradeName}}</div>
            <div>{{l.result}}</div>
        </div>
        <Pagination :size=list.length :pageLimit=8 style="margin:20px 0"/>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    //作废
    export default {
        name: "ResultDetail",
        components:{Pagination},
        data(){
            return{
                list: [
                    {studentId:"1",studentName: "aa", gradeName: "111", result: 12},
                    {studentId:"2",studentName: "bb", gradeName: "111", result: 34},
                    {studentId:"3",studentName: "cc", gradeName: "111", result: 56},
                ]
            }
        },
        created() {

        },
        methods:{
        }

    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
</style>
